import {useCallback} from 'react';
import {useTracking} from '../utils/utils';
import {trackExperimentActivation} from '@aboutyou/legacy-tracking-sdk';

export const useExperimentActivation = () => {
  const {TrackingClient} = useTracking();

  return useCallback(
    (experiment: {name: string; value: string}) => {
      TrackingClient.track(
        trackExperimentActivation({
          testName: experiment.name,
          testVariation: experiment.value,
        }),
      );
    },
    [TrackingClient],
  );
};
